import { dashboardAnalytics, getFarmStatistics } from "../../helpers/apis";
import { DASHBOARD_REQUEST, DASHBOARD_SUCCESS, DASHBOARD_ERROR, FARM_STATISTICS_REQUEST, FARM_STATISTICS_SUCCESS, FARM_STATISTICS_ERROR } from "./actionTypes";
import { showToast } from "../toast/reducer";

export const fetchDashboardAnalytics = () => async (dispatch) => {
  try {
    dispatch({ type: DASHBOARD_REQUEST });

    const response = await dashboardAnalytics(); // API call

    dispatch({
      type: DASHBOARD_SUCCESS,
      payload: response.data, // { totalUsers, totalFarmhouses, totalBookings, totalIncome }
    });

  } catch (error) {
    dispatch({
      type: DASHBOARD_ERROR,
      payload: error?.response?.data || error.message,
    });
  }
};

export const fetchFarmStatistics = (farmhouseId) => async (dispatch) => {
  try {
    dispatch({ type: FARM_STATISTICS_REQUEST });

    const response = await getFarmStatistics(farmhouseId);

    if (!response.error) {
      dispatch({
        type: FARM_STATISTICS_SUCCESS,
        payload: response.data,
      });
    } else {
      const errorMsg = response.msg || "Failed to fetch farm statistics";
      dispatch(showToast({ type: "error", msg: errorMsg }));
      dispatch({
        type: FARM_STATISTICS_ERROR,
        payload: errorMsg,
      });
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.msg || error.message || "Failed to fetch farm statistics";
    dispatch(showToast({ type: "error", msg: errorMsg }));
    dispatch({
      type: FARM_STATISTICS_ERROR,
      payload: errorMsg,
    });
  }
};
